import React from 'react';
import mainImage from './data/main-image.jpg';

export const About = () => {
  return (
    <div className="about" id="about">
      <div className="main-image">
        <img src={mainImage} alt="Main" />
      </div>
      <div className="about-text">
        <div className="block1">
          <p>Юрист</p>
          <p>Володимир</p>
          <p>Красіловський</p>
        </div>
        <div className="block2">
          <p className="block2-heading">Сімейне право</p>
          <p className="block2-text">Досвід: 900+ виграних справ</p>
          <p className="block2-text">Працюю по всій Україні</p>
        </div>
      </div>
    </div>
  );
};
